import React from 'react'
import './Square.css'

interface iSquare {
  title: string
  bodyText: string
  top?: number | string
  left?: number | string
  bottom?: number | string
  right?: number | string
}

const Square = ({ title, bodyText, top, left,bottom, right }: iSquare) => {

  const style = {
    top: top,
    left: left,
    bottom: bottom,
    right: right
  }

  return (
    <div style={style} className='square-container' >
      <h4 className='text-uppercase '>
        {title}
      </h4>
      <div>
        {bodyText}
      </div>

    </div>
  )
}

export default Square